/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A5Inputs */

const en_pc_faq_a5 = /** @type {(inputs: Pc_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The web version is a WebAssembly app that runs entirely inside your browser tab. There is no server-side processing, so your PDF never leaves your device.`)
};

const zh_pc_faq_a5 = /** @type {(inputs: Pc_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。网页版是完全在浏览器标签页内运行的 WebAssembly 应用，没有任何服务器端处理，你的 PDF 不会离开你的设备。`)
};

/**
* | output |
* | --- |
* | "No. The web version is a WebAssembly app that runs entirely inside your browser tab. There is no server-side processing, so your PDF never leaves your device." |
*
* @param {Pc_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a5 = /** @type {((inputs?: Pc_Faq_A5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a5(inputs)
	return zh_pc_faq_a5(inputs)
});
export { pc_faq_a5 as "pc.faq.a5" }